/** So'z kartochkasi (demo `cardView`), «card» (dars 1-bosqich) va «flip» (kartochkalar) qadamlari. */
import { useEffect, useState } from 'react';
import { POS, wordRe } from '../../../data';
import type { Word } from '../../../data/types';
import { t, tn } from '../../../i18n';
import { speak } from '../../../lib/speech';
import { knowSound } from '../../../lib/sound';
import { toast } from '../../../lib/toast';
import { Ic } from '../../../ui/Icon';
import { HardBtn } from '../../../ui/HardBtn';
import { next, prev, pushStep, toggleKnown, useLesson, type Step } from '../engine';
import { Frame } from './common';

function Example({ w }: { w: Word }) {
  const m = w.ex.match(wordRe(w));
  if (!m || m.index === undefined) return <p>{w.ex}</p>;
  return <p>{w.ex.slice(0, m.index)}<mark>{m[1]}</mark>{w.ex.slice(m.index + m[0].length)}</p>;
}

export function CardView({ w, isCard, known, back, onFlip }: { w: Word; isCard: boolean; known: boolean; back: boolean; onFlip?: () => void }) {
  return (
    <div className="wcard">
      <div className="wbody">
        <div className="between">
          <div className="col g4"><div className="word">{w.w}</div><div className="row g8"><span className="ipa">{w.ipa}</span><span className="postag">{POS[w.pos] || w.pos}</span></div></div>
          <div className="row g8"><HardBtn id={w.id} /><button className="aud" id="au" aria-label={t('Tinglash')} onClick={() => speak(w.w)}><Ic n="vol" /></button></div>
        </div>
        <div className="hr" />
        <div id="back" hidden={!back} className="col g14">
          <div className="tr">{w.uz}</div>
          {w.ex && <div className="ex">
            <button className="spk" id="au2" aria-label={t('Misolni tinglash')} style={{ width: 32, height: 32 }} onClick={() => speak(w.ex)}><Ic n="vol" style={{ width: 16, height: 16 }} /></button>
            <div className="grow col g4"><Example w={w} />{w.exT && <p>{w.exT}</p>}</div>
          </div>}
        </div>
        {isCard
          ? (known ? <span className="soon" style={{ alignSelf: 'flex-start', background: 'var(--success-soft)', color: 'var(--success-ink)' }}>{t('Bilaman deb belgilandi')}</span> : null)
          : (!back ? <button id="flip" className="t13" style={{ fontWeight: 700, color: 'var(--primary-ink)', alignSelf: 'flex-start' }} onClick={onFlip}>{t('Tarjimani koʻrsatish')}</button> : null)}
      </div>
    </div>
  );
}

const EMPTY: number[] = [];
export function CardStep({ s }: { s: Step }) {
  const w = s.w!;
  // L null bo'lib qolganda (quit/reset) selektorlar yiqilmasin
  const nw = useLesson((st) => st.L?.nw ?? EMPTY), known = useLesson((st) => st.L?.known ?? EMPTY), due = useLesson((st) => st.L?.due ?? EMPTY);
  const idx = nw.indexOf(w.id), n = nw.length, isKnown = known.includes(w.id), last = idx === n - 1;
  useEffect(() => { speak(w.w); }, [w.id]); // eslint-disable-line
  const fw = () => { if (last && known.length === nw.length && !due.length) toast(t('Hamma soʻzlarni bilasiz — dars yakunlandi')); next(); };
  return (
    <Frame foot={<>
      <button className="btn soft sq" id="pv" aria-label={t('Oldingi soʻz')} disabled={idx === 0} onClick={prev}><Ic n="back" /></button>
      <button className="btn soft" style={{ flex: '1 1 0', minWidth: 0 }} id="know" aria-pressed={isKnown} {...(isKnown ? { 'data-k': '1' } : {})} onClick={() => { knowSound(!isKnown); toggleKnown(w.id); }}>{isKnown ? t('Bilaman ✓') : t('Bilaman')}</button>
      {last
        ? <button className="btn" id="fw" style={{ flex: '2 1 0', minWidth: 0, whiteSpace: 'nowrap', fontSize: 15 }} onClick={fw}>{t('Tekshirishni boshlash')}</button>
        : <button className="btn sq" id="fw" aria-label={t('Keyingi soʻz')} onClick={fw}><Ic n="back" style={{ transform: 'scaleX(-1)' }} /></button>}
    </>}>
      <div className="between"><span className="tag">{tn('YANGI SOʻZ · #/#', idx + 1, n)}</span><span className="t12" style={{ fontWeight: 700 }}>{w.topic}</span></div>
      <CardView w={w} isCard known={isKnown} back />
    </Frame>
  );
}

export function FlipStep({ s }: { s: Step }) {
  const w = s.w!;
  const [back, setBack] = useState(false);
  useEffect(() => { speak(w.w); }, [w.id]); // eslint-disable-line
  return (
    <Frame foot={<>
      <button className="btn soft" id="again" onClick={() => { pushStep({ t: 'flip', w }); next(); }}>{t('Yana')}</button>
      <button className="btn" id="nxt" onClick={() => { if (!back) { setBack(true); return; } next(); }}>{t('Keyingi')}</button>
    </>}>
      <div className="between"><span className="tag">{t('KARTOCHKA')}</span><span className="t12" style={{ fontWeight: 700 }}>{w.topic}</span></div>
      <CardView w={w} isCard={false} known={false} back={back} onFlip={() => setBack(true)} />
    </Frame>
  );
}
